import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { FcmNotification } from "./../../../models/common";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { ApiService } from "src/app/providers/api.service";
import { InvoiceComponent } from "../invoice/invoice.component";
import { Subscription } from "rxjs";
import { LoaderServiceService } from "src/app/providers/loader-service.service";

@Component({
  selector: 'sm-cancel-delete-activity-for-booking-and-invoice',
  templateUrl: './cancel-delete-activity-for-booking-and-invoice.component.html',
  styleUrls: ['./cancel-delete-activity-for-booking-and-invoice.component.scss']
})
export class CancelDeleteActivityForBookingAndInvoiceComponent implements OnInit, OnDestroy {
  refund: boolean = false
  isEntityForeign: string = localStorage.getItem(
    SM_CONSTANTS.IS_ENTITY_FOREIGN
  )!;
  advancePaymentType: number = 1;
  public newbookingData: any = {
    price: 0,
  };
  toShowNotify: boolean = false;
  notAllowedNumbers = [
    "0000000000",
    "1111111111",
    "2222222222",
    "3333333333",
    "4444444444",
    "5555555555",
    "6666666666",
    "7777777777",
    "8888888888",
    "9999999999",
    "1234567890",
    "1000000000",
  ];
  notify: boolean = false;
  countryInfo: any =
    typeof sessionStorage.getItem(
      SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
    ) == "string"
      ? JSON.parse(
          sessionStorage.getItem(
            SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
          )!
        )
      : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT);

  customerPayment: any;

  private _apiSubscription: Subscription = new Subscription();
  selectedBookingType: number = 1;
  selectedPaymentMode: string = "Cash";
  serviceList: any = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    public _modelRef: MatDialog,
    private loader: LoaderServiceService,
    private activemodal: MatDialogRef<CancelDeleteActivityForBookingAndInvoiceComponent>
  ) {}
  ngOnInit(): void {
    console.log(this.parentData);
  }
  transferToWallet() {
    console.log(this.parentData);
    this.activemodal.close({refund_status: 2})
  }
  refundOnline() {
    console.log(this.parentData);
    this.activemodal.close({refund_status: 1})
  }

  changeChip(value: string) {
    this.selectedPaymentMode = value;
  }

  formatDateString(): string {
    const now = new Date();

    const options: Intl.DateTimeFormatOptions = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // Ensures 24-hour format
    };

    const formattedDate = new Intl.DateTimeFormat(
      "en-CA",
      options
    ).formatToParts(now);

    let year = "",
      month = "",
      day = "",
      hours = "",
      minutes = "",
      seconds = "";

    formattedDate.forEach((part) => {
      if (part.type === "year") year = part.value;
      if (part.type === "month") month = part.value;
      if (part.type === "day") day = part.value;
      if (part.type === "hour") hours = part.value;
      if (part.type === "minute") minutes = part.value;
      if (part.type === "second") seconds = part.value;
    });

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  changeAdvancePaymentType(event: any) {
    if (event.value == 1) {
      this.customerPayment = this.parentData.data.payment_due;
    } else if (event.value == 2) {
      this.customerPayment = this.parentData.data?.advance_payment_required;
    }
  }
}
